import * as React from 'react'
import { FieldProps, Field } from 'formik'
import { ControlField } from '@espoon-voltti/react-components/elements/form'
import { fieldState, ErrorMessage, setFieldValue } from '../formik-util'
import { InputProps } from './types'
import { EuroInput } from './euro-input'

interface EuroInputProps extends InputProps {
  max?: number
  min?: number
}
export const FormEuroField = (p: EuroInputProps) => (
  <Field name={p.name}>
    {({ field, form }: FieldProps) => (
      <ControlField
        required={p.required}
        dataQa={p.dataQa}
        {...field}
        label={p.label}
        state={fieldState(field.name, form)}
        disabled={p.disabled}
        message={<ErrorMessage name={field.name} />}
      >
        <EuroInput
          id={field.name}
          name={field.name}
          value={field.value}
          onChange={setFieldValue(form, field.name)}
          onBlur={field.onBlur}
          disabled={p.disabled}
          max={p.max}
          min={p.min}
        />
      </ControlField>
    )}
  </Field>
)
